export const extensionRoutes = [  {
    path: 'extensions/ecommerce',
    loadChildren: () => import('./extensions/87d9badd20dea844ca7227e4a924a938b908d0e4d168a26aa8c8f3804e338133/ecommerce-common-ui.module').then(m => m.EcommerceUICommonModule),
  },
  {
    path: 'extensions/after-sale',
    loadChildren: () => import('./extensions/095f7e13f44ad6cd8c73f9a962f8c599c7fcfe4bf98f607fb0fb1afb98380302/after-sale-ui.module').then(m => m.AfterSaleUiModule),
  }];
